"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _withTheme = require("../../wrappers/with-theme");

var _Item = _interopRequireDefault(require("./Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MobileSidebar = function MobileSidebar(_ref) {
  var open = _ref.open,
      toggle = _ref.toggle,
      _ref$logo = _ref.logo,
      logo = _ref$logo === void 0 ? null : _ref$logo,
      _ref$menuItems = _ref.menuItems,
      menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: open ? 'block' : 'none'
    },
    className: "md:hidden"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixed inset-0 z-20 transition-opacity ease-linear duration-300"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute inset-0 bg-gray-600 opacity-75"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixed inset-0 flex z-40"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex flex-col max-w-xs w-full transform ease-in-out duration-300"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 right-0 -mr-14 p-1"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: toggle,
    className: "flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "h-6 w-6 text-gray-900",
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6 18L18 6M6 6l12 12"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 h-0 pt-2 pb-4 overflow-y-auto overflow-x-hidden ".concat(theme.menuBg)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-6 pt-4 pb-8 logo-text gray-900"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: '/',
    className: "flex-shrink-0 flex items-center ".concat(theme.text)
  }, logo)), /*#__PURE__*/_react["default"].createElement("nav", {
    className: "flex-1"
  }, menuItems.map(function (page, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: page.sectionClass
    }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      to: page.path,
      icon: page.icon,
      theme: theme,
      className: page.itemClass
    }, page.name), page.children ? page.children.map(function (child, x) {
      return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
        key: x,
        to: child.path,
        icon: child.icon,
        theme: theme,
        className: child.itemClass
      }, child.name);
    }) : '');
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0 w-14"
  })));
};

var DesktopSidebar = function DesktopSidebar(_ref2) {
  var _ref2$menuItems = _ref2.menuItems,
      menuItems = _ref2$menuItems === void 0 ? [] : _ref2$menuItems,
      fixed = _ref2.fixed,
      topMenu = _ref2.topMenu,
      _ref2$logo = _ref2.logo,
      logo = _ref2$logo === void 0 ? null : _ref2$logo,
      rest = _objectWithoutProperties(_ref2, ["menuItems", "fixed", "topMenu", "logo"]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden md:flex md:flex-shrink-0 z-20 ".concat(theme.sidebarBg, " ").concat(fixed ? 'fixed top-0 h-screen' : '', " ").concat(theme.sidebarBorder)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col w-".concat(theme.sidebarW)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-".concat(theme.sidebarW, " flex-1 flex flex-col pb-4 overflow-y-auto overflow-x-hidden scrollbar")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-16"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: '/',
    className: "".concat(theme.text)
  }, logo)), topMenu ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-16"
  }, topMenu) : null, /*#__PURE__*/_react["default"].createElement("nav", {
    className: "flex-1"
  }, menuItems.map(function (page, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: page.sectionClass
    }, /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      to: page.path,
      icon: page.icon,
      theme: theme,
      className: page.itemClass
    }, page.name), page.children ? page.children.map(function (child, x) {
      return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
        key: x,
        to: child.path,
        icon: child.icon,
        theme: theme,
        className: child.itemClass
      }, child.name);
    }) : '');
  })))));
};

var _default = function _default(_ref3) {
  var props = _extends({}, _ref3);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MobileSidebar, props), /*#__PURE__*/_react["default"].createElement(DesktopSidebar, props));
};

exports["default"] = _default;